
 <template>
  <BlockEditor v-if="switchToEditor" :contentId = "blockId" :styleObject = "getTextStyle(data?.style)" :data="data"/>
  <div  @click = "clicked = true" v-else :style="getTextStyle(data?.style)" v-html="parsedText"></div>
</template>

<script>
import { mapState } from 'vuex';
import DOMPurify from 'dompurify';
import { getXmlValueByPath } from '@/utils/getXmlValueByPath';
import { replacePlaceholders } from '@/utils/replacePlaceholders';
import BlockEditor from './EditorHelper/BlockEditor.vue';


export default {
  name: 'TextBlock',
  components: {BlockEditor},
  props: {
    data: Object,
    blockId: String,
    dynamicIndex: {
      type: Number,
      default: 0
    }
  },
  data() {return {
    clicked: false
  }},
  computed: {
    ...mapState(['placeholdersEnabled', 'emailData', 'xPathPlaceholders', 'sharedData']),
    switchToEditor() {
    return this.sharedData && this.sharedData.id == this.blockId; 
  },
    parsedText() {
      let text = DOMPurify.sanitize(this.data?.props?.text, {ADD_ATTR: ['target', 'rel']})|| ''; // cleans content for safety reasons
      let fontSize = this.data.style?.fontSize || this.emailData.root.data.fontSize

      // Platzhalter durch Kundendaten ersetzen
      if (this.placeholdersEnabled) {
        text = replacePlaceholders(text, true, this.data.props.rules, this.dynamicIndex)
      }else{
        text = text.replace(/\[\[(.*?)\]\]/g,  function(match, p1){
              // Formatierung: Kursiv und blau
             return `<span style="color: #05bbef"><span class="material-symbols-outlined" style="font-size : ${fontSize - 5}px"> bolt</span>${p1} <span class="material-symbols-outlined" style="font-size :  ${fontSize - 5}px"> bolt</span></span> `;
              });
        text = text.replace(/\%\%(.*?)\%\%/g,  function(match, p1){
              // Formatierung: Kursiv und rot
              return `<span style="color: red"><span class="material-symbols-outlined" style="font-size : ${fontSize - 5}px"> rule</span>${p1} <span class="material-symbols-outlined" style="font-size :  ${fontSize - 5}px"> rule</span></span> `;
              });
      }
    return text
  }
  },
  methods: {
    conditionalTextTrue(text){
        let newText
        const ruleset = this.data.props.rules.filter(r => r.replacedText == text);
        ruleset.forEach(rule => {
          const statement = rule.statement
          const xPath = (statement) ? this.xPathPlaceholders.find(p => p.placeholder === statement)?.xpath : null
          const dataStatementValue = getXmlValueByPath(xPath) 
          const value = rule.value
          const operator = rule.operator
          console.log(dataStatementValue == value)
          switch (operator){
              case '==':
              case '=': //in case of user mistake
                if (dataStatementValue == value) {
                  newText = rule.text
                  return newText
                }
              case '<':
                if (dataStatementValue < value) {
                  newText = rule.text
                  return newText
                }
              case '>':
                if (dataStatementValue > value) {
                  newText = rule.text
                  return newText
                }
              case '!=':
                if (dataStatementValue !== value) {
                  newText = rule.text
                  return newText
                }
          }
        }
        )
        return newText
      },
    getTextStyle(style) {
      const fontFamilyMapping = {
        BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
        ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
        GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
        HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
        ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
        MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
        BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
        MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
        MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
        SIMPLE: 'Arial',
        DEFAULT: 'inherit'
      };
      const fontFamily = fontFamilyMapping[style?.fontFamily] || fontFamilyMapping.DEFAULT;
      const defaultTextAlign = 'left';
      const defaultFontSize = this.emailData.root.data.fontSize;
      const padding = style?.padding || { top: 0, bottom: 0, left: 0, right: 0 };
      return {
        color: style?.color || null, 
        backgroundColor: style?.backgroundColor || null, 
        fontWeight: style?.fontWeight || 'normal',
        textAlign: style?.textAlign || defaultTextAlign,
        fontSize: style?.fontSize ? `${style.fontSize}px` : `${defaultFontSize}px`,
        fontFamily: fontFamily,
        padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
      };
    },
  },
};
</script>
<style scoped>
a{
  text-decoration: none;
}
</style>
